var jsonData = null;
var filtered = null;
var cardCache = {}; // Global cache to store fetched cards
var batchSize = 6; // Number of cards to load per batch
var currentPage = getUrlParameter('page') && getUrlParameter('page') > 0 ? getUrlParameter('page') - 1 : 0; // Initialize the current batch index
var ajaxRequests = {}; // these will be aborted when filtering
const section = $('[data-section="newsListing"]');

$(function () {
	fetchNewData();
});

async function fetchNewData() {
	if (jsonData === null) {
		try {
			const response = await $.ajax({
				type: 'get',
				url: '/all-news.json',
			});
			jsonData = response.data;
			jsonData.sort((a, b) => (b.featured === true) - (a.featured === true));
			console.log('fetchNewData SUCCESS');
			console.log(jsonData);
			filterAndDisplayCards();
		} catch (error) {
			console.log('fetchNewData ERROR');
			console.log(error);
		}
	}
}

function filterAndDisplayCards() {
	if (jsonData === null) {
        console.log('JSON data is not available. Please fetch it first.');
        return false;
    }
    
	var type = getUrlParameter('type') ? getUrlParameter('type') : 'news';
	console.log('type ' + type)

	$('.nav-radio[data-news-type]').removeClass('active');
	$('.nav-radio[data-news-type="' + type + '"]').addClass('active');

    filtered = filterCards(jsonData, type);

    console.log('FILTERED LENGTH ' + filtered.length)

    var startTime2 = performance.now();
    
    loadBatch(filtered, currentPage)
        .then(function () {
            console.log('All fetchCards have been loaded');
            $('[data-loading]').addClass('loaded');
            $('[data-pagination]').addClass('loaded');

        })
        .catch(function (error) {
            console.error('Error while loading batch:', error);
        });

    pagination(currentPage+1);
    
    var endTime2 = performance.now();
    var duration2 = (endTime2 - startTime2) / 1000;
    console.log('filtering ' + duration2.toFixed(2) + ' seconds')

}

function filterCards(data, type) {
	if (!data || !Array.isArray(data)) {
		return [];
	}
	var startTime = performance.now();
	
	var filteredCardsIds = data;
	
	filteredCardsIds = filteredCardsIds.filter(function (card) {
		return card.type == type;
	});


	// console.log(filteredCardsIds)
	
	var endTime = performance.now();
	var duration = (endTime - startTime) / 1000;
	// console.log('get card ' + duration.toFixed(2) + ' seconds')
	
	return filteredCardsIds.map(function (card) {
		return card.id;
	});
}

function loadBatch(filtered, page) {
	console.log('------------------------------- LOADING BATCH FOR PAGE ' + page)

    $('[data-listing]').children().remove();

    var actualBatchSize = batchSize;
    if (page === 0) {
        // Check if there are featured entries of the selected type
        var type = getUrlParameter('type') ? getUrlParameter('type') : 'news';
        var hasFeaturedOfType = jsonData.some(card => card.type === type && card.featured === true);
        actualBatchSize = hasFeaturedOfType ? batchSize + 1 : batchSize;
		console.log('hasFeaturedOfType ' + hasFeaturedOfType)
		console.log('actualBatchSize ' + actualBatchSize)
    }
    console.log('batchSize ' + actualBatchSize);

	var start = page * actualBatchSize;
	var end = Math.min(start + actualBatchSize, filtered.length);
	console.log('batch ' + start + ' - ' + end)
	var batchToLoad = filtered.slice(start, end);
    console.log('filtered')
    console.log(batchToLoad)
	if (batchToLoad.length === 0) {
		// No more cards to load
		console.log('All cards loaded');
		// return;
		return Promise.resolve(); // Resolve immediately since there's nothing to load

	}
	var count = 0;
	var promises = batchToLoad.map(function (value) {
		count++;
		return fetchCard(value, count);
	});
	return Promise.all(promises); // Returns a Promise that resolves when all fetchCard calls are completed

}

function fetchCard(id, order) {
	return new Promise((resolve, reject) => {

		if (ajaxRequests[id]) {
			ajaxRequests[id].abort(); // Abort the previous request for the same card ID
		}

		if (cardCache[id]) {
			$('[data-listing]').append(cardCache[id]); // Serve from cache
			console.log('Card served from cache for id: ' + id);
            $('[data-listing] [data-filter-card-id="' + id + '"]').css('order', order);
			resolve();
		} else {
			ajaxRequests[id] = $.ajax({
				type: 'get',
				url: '/news-card/' + id,
				success: function (response) {
					$('[data-listing]').append(response);
					console.log('fetchCard success for id: ' + id);
					cardCache[id] = response;
					$('[data-listing] [data-filter-card-id="' + id + '"]').css('order', order);
					delete ajaxRequests[id]; // Remove the request reference when it's completed
					resolve();
				},
				error: function (error) {
					console.log('Error fetchCard for id: ' + id);
					console.log(error);
					delete ajaxRequests[id]; // Remove the request reference when it's completed
					reject(error);
				},
			});
		}
	});
}

///////////////////////////////////////





// HANDLE PAGINATION CLICKS

$(document).on('click','[data-pagination] .page:not(.active)', function() {

	for (var id in ajaxRequests) {
		if (ajaxRequests.hasOwnProperty(id)) {
			ajaxRequests[id].abort(); // Abort all ongoing requests
		}
	}

	var page = parseInt($(this).attr('data-page'));
	var currentUrl = window.location.href;
	currentUrl = decodeURIComponent(currentUrl);
	var url = new URL(currentUrl);
	url.searchParams.set('page', page);
	window.history.replaceState({}, document.title, url.toString());
	
	$('[data-loading]').removeClass('loaded');
	$('[data-pagination]').removeClass('loaded');
	
	loadBatch(filtered, page - 1)
		.then(function () {
			console.log('All fetchCards have been loaded');
			$('[data-loading]').addClass('loaded');
			$('[data-pagination]').addClass('loaded');
		})
		.catch(function (error) {
			console.error('Error while loading batch:', error);
		});
	$('html, body').animate({
		scrollTop: section.offset().top
	}, 300);

	pagination(page);

});

$(document).on('click','[data-pagination] .page-nav', function() {
	var page = parseInt($(this).attr('data-page'));
	$('[data-pagination] .page[data-page="' + page + '"]').trigger('click');
});

///////////////////////////////////////





// RENDER PAGINATION

function pagination(thisPage) {
	var pagination = $('[data-pagination]');
	pagination.children().remove();
	if (!filtered.length) {
		return false;
	}
	var totalCards = filtered.length;
	var totalPages = Math.ceil(totalCards / batchSize);
	
	if (totalPages == 1) return false;

	var oneBeforeActive = thisPage - 1;
	var twoBeforeActive = thisPage - 2;
	var oneAfterActive = thisPage + 1;
	var twoAfterActive = thisPage + 2;
	var startPage = 1;
	var endPage = totalPages;

	var pagesHtml = ``;

	pagesHtml = pagesHtml + '<div class="page ' + (thisPage == startPage ? 'active' : '') + '" data-page="' + startPage + '"><span>' + startPage + '</span></div>';

	if ((totalPages-1) <= 5) {
		for (var i = 2; i <= totalPages-1; i++) {
			pagesHtml = pagesHtml + '<div class="page ' + (thisPage == i ? 'active' : '') + '" data-page="' + i + '"><span>' + i + '</span></div>';
		}
	} else {
		var dotsAddedBefore = false;
		var dotsAddedAfter = false;
		for (var i = 2; i <= totalPages-1; i++) {
			if (i == thisPage || i == oneBeforeActive || i == twoBeforeActive || i == oneAfterActive || i == twoAfterActive) {
				pagesHtml = pagesHtml + '<div class="page ' + (thisPage == i ? 'active' : '') + '" data-page="' + i + '"><span>' + i + '</span></div>';
			} else {
				if (!dotsAddedBefore && i <= thisPage) {
					pagesHtml = pagesHtml + '<div class="page inactive">...</div>';
					dotsAddedBefore = true;
				}
				if (!dotsAddedAfter && i >= thisPage) {
					pagesHtml = pagesHtml + '<div class="page inactive">...</div>';
					dotsAddedAfter = true;
				}
			}
		}
	}

	pagination.append(pagesHtml);
}

///////////////////////////////////////





// FILTER BUTTONS

$(document).on('click', '.nav-radio[data-news-type]', function(e) {
	var type = $(this).attr('data-news-type');
	$('.nav-radio[data-news-type]').removeClass('active');
	$(this).addClass('active');

	for (var id in ajaxRequests) {
		if (ajaxRequests.hasOwnProperty(id)) {
			ajaxRequests[id].abort(); // Abort all ongoing requests
		}
	}

	var filterValue = $(this).attr('data-news-type').toString();

	var currentUrl = window.location.href;
	currentUrl = decodeURIComponent(currentUrl);
	var url = new URL(currentUrl);

    url.searchParams.set('type', filterValue);

	url.searchParams.set('page', 1);
		
	window.history.replaceState({}, document.title, url.toString());

	console.log('Filter value modified in TYPE: ' + filterValue);

    $('html, body').animate({
        scrollTop: section.offset().top
    }, 300);

	$('[data-loading]').removeClass('loaded');
	$('[data-pagination]').removeClass('loaded');

	filterAndDisplayCards();

});

///////////////////////////////////////